import React, { useEffect, useContext, useState, useRef } from "react";

//jQuery initialization
import $ from "jquery";

//functions
import {
  _t,
  getSystemSettings,
  managePageHrefLink,
  checkPermission,
  managePageHrefLinkMobile,
} from "../../../../functions/Functions";

import { useTranslation } from "react-i18next";
import { SettingsContext } from "../../../../contexts/Settings";
import { UserContext } from "../../../../contexts/User";


const ManageSidebar = () => {
  const { t } = useTranslation();
  const { showManageStock, flag, setFlag, generalSettings } = useContext(SettingsContext);
  let { authUserInfo } = useContext(UserContext);

  const [searchTerm, setSearchTerm] = useState("");
  const [matchCount, setMatchCount] = useState(null);
  const searchInputRef = useRef(null);

  useEffect(() => {
    handleJquery();
    handleJquerySub();
    // Record initially active Level 1 categories
    $(".fk-pos-nav > .fk-pos-nav__list-has-sub").each(function () {
      if ($(this).hasClass("active")) {
        $(this).attr("data-default-active", "true");
      }
    });
    // Record initially active Level 2 sub-trees
    $(".fk-pos-nav__list-has-sub__tree").each(function () {
      if ($(this).hasClass("active")) {
        $(this).attr("data-default-active", "true");
      }
    });
  }, []);

  // Real-time search filter effect supporting nested sub-trees
  useEffect(() => {
    const term = searchTerm.toLowerCase().trim();

    if (!term) {
      // Restore all categories, sub-trees and sub-items
      $(".fk-pos-nav > .fk-pos-nav__list").show();
      $(".fk-pos-nav__sub-list").show();
      $(".fk-pos-nav__list-has-sub__tree").show();
      $(".fk-sm-nav__bar > .fk-sm-nav__list").show();

      // Restore Level 1 category active state
      $(".fk-pos-nav > .fk-pos-nav__list-has-sub").each(function () {
        if ($(this).attr("data-default-active") === "true") {
          $(this).addClass("active").children(".fk-pos-nav__sub").show();
        } else {
          $(this).removeClass("active").children(".fk-pos-nav__sub").hide();
        }
      });

      // Restore Level 2 sub-tree active state
      $(".fk-pos-nav__list-has-sub__tree").each(function () {
        if ($(this).attr("data-default-active") === "true") {
          $(this).addClass("active").find(".fk-pos-nav__sub__tree").show();
        } else {
          $(this).removeClass("active").find(".fk-pos-nav__sub__tree").hide();
        }
      });

      setMatchCount(null);
      return;
    }

    let count = 0;

    // Filter large screen navigation
    $(".fk-pos-nav > .fk-pos-nav__list-has-sub").each(function () {
      const $category = $(this);
      const catName = $category.children("a").text().toLowerCase();
      const isCatMatch = catName.includes(term);

      let categoryHasMatches = false;

      // Check direct items under this category
      $category.children(".fk-pos-nav__sub").children(".fk-pos-nav__sub-list").each(function () {
        const $item = $(this);
        const itemText = $item.text().toLowerCase();

        if (isCatMatch || itemText.includes(term)) {
          $item.show();
          categoryHasMatches = true;
          count++;
        } else {
          $item.hide();
        }
      });

      // Check nested sub-trees under this category
      $category.children(".fk-pos-nav__sub").children(".fk-pos-nav__list-has-sub__tree").each(function () {
        const $subTree = $(this);
        const subTreeTitle = $subTree.children("a").text().toLowerCase();
        const isSubTreeMatch = isCatMatch || subTreeTitle.includes(term);

        let subTreeHasMatches = false;

        $subTree.find(".fk-pos-nav__sub-list").each(function () {
          const $subItem = $(this);
          const subItemText = $subItem.text().toLowerCase();

          if (isSubTreeMatch || subItemText.includes(term)) {
            $subItem.show();
            subTreeHasMatches = true;
            count++;
          } else {
            $subItem.hide();
          }
        });

        if (subTreeHasMatches || isSubTreeMatch) {
          $subTree.show().addClass("active");
          $subTree.find(".fk-pos-nav__sub__tree").show();
          categoryHasMatches = true;
        } else {
          $subTree.hide();
        }
      });

      if (categoryHasMatches || isCatMatch) {
        $category.show().addClass("active");
        $category.children(".fk-pos-nav__sub").show();
      } else {
        $category.hide();
      }
    });

    // Filter small screen (mobile) items
    $(".fk-sm-nav__bar > .fk-sm-nav__list").each(function () {
      const $item = $(this);
      const itemText = $item.text().toLowerCase();
      if (itemText.includes(term)) {
        $item.show();
      } else {
        $item.hide();
      }
    });

    setMatchCount(count);
  }, [searchTerm]);

  //jQuery goes here
  const handleJquery = () => {
    var posHasSub = $(".fk-pos-nav__list-has-sub");
    var posSub = $(".fk-pos-nav__sub");
    $(".fk-pos-nav__list-has-sub > a").on("click", function (e) {
      e.preventDefault();
    });
    posHasSub.on("click", function () {
      $(this).find(posSub).slideDown();
      $(this).siblings().find(posSub).slideUp();
      $(this).addClass("active").siblings().removeClass("active");
      $(this).attr("data-default-active", "true").siblings().removeAttr("data-default-active");
    });


    //nested dropdown
    var posSubTree = $(".fk-pos-nav__sub__tree")
    if (flag === false) {
      //initially child dropdown closed
      posSubTree.slideUp();
    }

  };

  //nested dropdown
  const handleJquerySub = () => {
    var posHasSubTree = $(".fk-pos-nav__list-has-sub__tree");
    var posSubTree = $(".fk-pos-nav__sub__tree");
    setFlag(true);

    $(".fk-pos-nav__list-has-sub__tree > a").on("click", function (e) {
      e.preventDefault();
      var parent = $(this).parent('.fk-pos-nav__list-has-sub__tree');
      if (parent.hasClass('active')) {
        parent.find(posSubTree).slideUp();
        parent.removeClass('active');
        parent.removeAttr("data-default-active");
      } else {
        posSubTree.slideUp();
        posHasSubTree.removeClass('active').removeAttr("data-default-active");
        parent.find(posSubTree).slideDown();
        parent.addClass("active").attr("data-default-active", "true");
      }
    });
    if (posHasSubTree.hasClass('active')) {
      posHasSubTree.siblings(':not(.active)').find(posSubTree).slideUp();
    }

    if (!posHasSubTree.hasClass('active') && flag === true) {
      posHasSubTree.find(posSubTree).slideUp();
    }
  };

  let url = window.location.pathname;

  const renderSearchBar = (isMobile = false) => (
    <div className={`manage-sidebar-search-box ${isMobile ? "mb-3" : "mb-2"}`}>
      <div className="manage-sidebar-search-wrapper">
        <span className="manage-sidebar-search-icon">
          <i className="fa fa-search" aria-hidden="true"></i>
        </span>
        <input
          ref={isMobile ? null : searchInputRef}
          type="text"
          className="form-control manage-sidebar-search-input"
          placeholder={_t(t("Search menus..."))}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              setSearchTerm("");
            }
          }}
        />
        {searchTerm && (
          <button
            type="button"
            className="manage-sidebar-search-clear"
            onClick={() => {
              setSearchTerm("");
              if (!isMobile && searchInputRef.current) {
                searchInputRef.current.focus();
              }
            }}
            title={_t(t("Clear search"))}
          >
            <i className="fa fa-times-circle" aria-hidden="true"></i>
          </button>
        )}
      </div>
      {searchTerm.trim() && (
        <div className="manage-sidebar-search-meta d-flex justify-content-between align-items-center mt-1 px-1">
          <span className="badge badge-light manage-sidebar-badge">
            {matchCount !== null && (
              <>
                {matchCount}{" "}
                {matchCount === 1 ? _t(t("menu found")) : _t(t("menus found"))}
              </>
            )}
          </span>
          <button
            type="button"
            className="btn btn-link p-0 manage-sidebar-clear-link"
            onClick={() => setSearchTerm("")}
          >
            {_t(t("Clear"))}
          </button>
        </div>
      )}
    </div>
  );

  return (
    <>
      <style>{`
        .manage-sidebar-search-box {
          position: relative;
          width: 100%;
        }
        .manage-sidebar-search-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          background: #ffffff;
          border: 1.5px solid #d1d5db;
          border-radius: 8px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          transition: border-color 0.2s ease, box-shadow 0.2s ease;
          overflow: hidden;
        }
        .manage-sidebar-search-wrapper:focus-within {
          border-color: #0a8d6e;
          box-shadow: 0 0 0 3px rgba(10, 141, 110, 0.15);
        }
        .manage-sidebar-search-icon {
          position: absolute;
          left: 11px;
          color: #0a8d6e;
          font-size: 13px;
          pointer-events: none;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
        }
        .manage-sidebar-search-input {
          width: 100% !important;
          height: 38px !important;
          border: none !important;
          background: transparent !important;
          padding-left: 33px !important;
          padding-right: 30px !important;
          font-size: 13px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          box-shadow: none !important;
          outline: none !important;
        }
        .manage-sidebar-search-input::placeholder {
          color: #94a3b8 !important;
          font-size: 12.5px !important;
        }
        .manage-sidebar-search-clear {
          position: absolute;
          right: 8px;
          background: transparent;
          border: none;
          color: #94a3b8;
          padding: 4px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          line-height: 1;
          z-index: 2;
          transition: color 0.15s ease;
        }
        .manage-sidebar-search-clear:hover {
          color: #ef4444;
        }
        .manage-sidebar-badge {
          background-color: #e6f4ea !important;
          color: #0a8d6e !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          padding: 3px 8px !important;
          border-radius: 12px !important;
        }
        .manage-sidebar-clear-link {
          font-size: 11px !important;
          color: #64748b !important;
          text-decoration: none !important;
        }
        .manage-sidebar-clear-link:hover {
          color: #ef4444 !important;
          text-decoration: underline !important;
        }
        .manage-sidebar-scroll {
          height: calc(100vh - 170px) !important;
          max-height: calc(100vh - 170px) !important;
          overflow-y: auto !important;
          overflow-x: hidden !important;
          -webkit-overflow-scrolling: touch !important;
          scrollbar-width: thin !important;
          scrollbar-color: rgba(0, 0, 0, 0.25) transparent !important;
        }
        .manage-sidebar-scroll::-webkit-scrollbar {
          width: 6px !important;
        }
        .manage-sidebar-scroll::-webkit-scrollbar-track {
          background: transparent !important;
        }
        .manage-sidebar-scroll::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.2) !important;
          border-radius: 4px !important;
        }
        .manage-sidebar-scroll::-webkit-scrollbar-thumb:hover {
          background: rgba(0, 0, 0, 0.35) !important;
        }
      `}</style>

      {/* Navigation for Small Screen  */}
      <div className="d-lg-none">
        <div className="row">
          <div className="col-12">
            {renderSearchBar(true)}
            <div className="fk-sm-nav" data-simplebar>
              <ul className="t-list fk-sm-nav__bar flex-row">
                {/* Foods */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage Food"
                  ) ? (
                  <>
                    {managePageHrefLinkMobile(
                      "/dashboard/manage/food/add-menu",
                      _t(t("Menu"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/food/department",
                      _t(t("Food Department"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/food/add-new",
                      _t(t("Add new item"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/food/meal-times",
                      _t(t("Meal Time"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/food/all-items",
                      _t(t("All Items"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/food/groups",
                      _t(t("Groups"))
                    )}

                    {parseInt(getSystemSettings(generalSettings, "foods_in_setting")) === 1 && managePageHrefLinkMobile(
                      "/dashboard/manage/food/sub-category",
                      _t(t("Sub Category"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/food/properties",
                      _t(t("Properties"))
                    )}
                    {managePageHrefLinkMobile(
                      "/dashboard/manage/food/properties-item",
                      _t(t("Properties Item"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/food/variations",
                      _t(t("Variations"))
                    )}

                    {
                      parseInt(getSystemSettings(generalSettings, "foods_in_setting")) === 1 && (
                        <>
                          {managePageHrefLinkMobile(
                            "/dashboard/manage/food/food-status",
                            _t(t("Food Status"))
                          )}

                          {managePageHrefLinkMobile(
                            "/dashboard/manage/food/product-type",
                            _t(t("Product Type"))
                          )}

                          {managePageHrefLinkMobile(
                            "/dashboard/manage/food/tax-group",
                            _t(t("Tax Group"))
                          )}

                          {managePageHrefLinkMobile(
                            "/dashboard/manage/food/packing-type",
                            _t(t("Packing Types"))
                          )}

                          {managePageHrefLinkMobile(
                            "/dashboard/manage/food/region",
                            _t(t("Regions"))
                          )}
                          {managePageHrefLinkMobile(
                            "/dashboard/manage/food/comment",
                            _t(t("Comment"))
                          )}
                          {managePageHrefLinkMobile(
                            "/dashboard/manage/food/variant",
                            _t(t("Variant"))
                          )}
                          {managePageHrefLinkMobile(
                            "/dashboard/manage/food/weight",
                            _t(t("Weight"))
                          )}
                          {managePageHrefLinkMobile(
                            "/dashboard/manage/food/generic",
                            _t(t("Generic Type"))
                          )}
                          {managePageHrefLinkMobile(
                            "/dashboard/manage/food/flavor",
                            _t(t("Flavor"))
                          )}
                          {managePageHrefLinkMobile(
                            "/dashboard/manage/food/production-unit",
                            _t(t("Product Unit"))
                          )}

                          {managePageHrefLinkMobile(
                            "/dashboard/manage/food/season",
                            _t(t("Seasons"))
                          )}
                        </>
                      )
                    }

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/food/add-voucher",
                      _t(t("Voucher Settings"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/food/add-cards",
                      _t(t("Card Settings"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/food/add-schemes",
                      _t(t("Offers"))
                    )}
                  </>
                ) : ""}

                {/* Stock */}
                {
                  showManageStock && (
                    <>
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Food Purchase"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/food-purchase",
                          _t(t("Food Purchase"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Purchase History"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/purchase-history-food",
                          _t(t("Purchase History"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Finished Goods"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/finished-goods-history",
                          _t(t("Finished Goods"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Finished Goods Transfer"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/finished-goods-transfer",
                          _t(t("Finished Goods Transfer"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Goods Acceptance"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/finished-goods-acceptance",
                          _t(t("Goods Acceptance"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Finished Goods Requisition"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/fg-requisition",
                          _t(t("Finished Goods Requisition"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Finished Goods Issuance"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/fg-issuance",
                          _t(t("Finished Goods Issuance"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS FG PI"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/fg-purchase",
                          _t(t("Finished Goods Purchase"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Finished Goods Discard"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/finished-goods-discard",
                          _t(t("Finished Goods Discard"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Goods Adjustment"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/finished-goods-adjustment",
                          _t(t("Goods Adjustment"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS FG Packing"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/fg-packing",
                          _t(t("FG Packing"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Sale Order"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/fg-sale-order",
                          _t(t("FG Sale Order"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Sale Order"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/fg-sale-invoice",
                          _t(t("FG Sale Invoice"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Sale Order"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/fg-sale-return",
                          _t(t("FG Sale Return"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS FG Hampers"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/gift-hampers",
                          _t(t("Gift Hampers"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS FG Hampers"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/gift-hampers-return",
                          _t(t("Gift Hampers Return"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Ingredient Group"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/ingredient-group",
                          _t(t("Ingredient Group"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Ingredient Group"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/brand",
                          _t(t("Brand"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Ingredient Unit"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/ingredient-unit",
                          _t(t("Ingredient Unit"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Ingredient Item"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/ingredient-item",
                          _t(t("Ingredient Item"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        (checkPermission(
                          authUserInfo.permissions,
                          "MS Peeling Process"
                        ) ||
                          checkPermission(
                            authUserInfo.permissions,
                            "MS Ingredient Item"
                          )) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/peeling-process",
                          _t(t("Peeling Process"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Gate Pass"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/gate-pass",
                          _t(t("Gate Pass"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Ingredient Item"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/ingredient-limit",
                          _t(t("Ingredient Limit"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Manage Supplier"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/manage-supplier",
                          _t(t("Manage Supplier"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Recipe"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/view-recipe",
                          _t(t("Recipe"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Recipe"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/bulk-update-recipe",
                          _t(t("Update Recipe"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Wastage Food"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/wastage-food",
                          _t(t("Wastage Food"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Production"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/production",
                          _t(t("Production"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Purchase Request"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/purchase-request",
                          _t(t("Purchase Request"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Purchase Order"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/purchase-order",
                          _t(t("Purchase Order"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Purchase Invoice"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/purchase-invoice",
                          _t(t("Purchase Invoice"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Purchase Return"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/purchase-return",
                          _t(t("Purchase Return"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Sale Invoice"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/sale-invoice",
                          _t(t("Sale Invoice"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Sale Invoice"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/sale-return",
                          _t(t("Sale Return"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Bank Drop"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/bank-drop",
                          _t(t("Bank Drop"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Goods Recieved Note"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/goods-received-note",
                          _t(t("Goods Recieved Note"))
                        )
                      ) : ""}

                      {parseInt(getSystemSettings(generalSettings, "foods_in_setting")) === 1 && authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Goods Recieved Note"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/goods-received-note-dept",
                          _t(t("GRN Department"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Stock Transfer"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/stock-consumption",
                          _t(t("Stock Consumption"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Closing Stock"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/closing-stock",
                          _t(t("Closing Stock"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Store Requisition"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/store-requisition",
                          _t(t("Store Requisition"))
                        )
                      ) : ""}
                      
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Stock Issuance"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/stock-issuance",
                          _t(t("Stock Issuance"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Store Requisition"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/stock-receiving",
                          _t(t("Stock Receiving"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Store Requisition"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/store-requisition-dept",
                          _t(t("Store Requisition Dept"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Stock Issuance"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/stock-issuance-dept",
                          _t(t("Stock Issuance Dept"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Store Requisition"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/stock-receiving-dept",
                          _t(t("Stock Receiving Dept"))
                        )
                      ) : ""}


                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Stock Transfer"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/stock-transfer",
                          _t(t("Stock Transfer"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Stock Adjustment"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/stock-adjustment",
                          _t(t("Stock Adjustment"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Opening Stock"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/opening-stock",
                          _t(t("Opening Stock"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Day End Setting"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/day-end-setting",
                          _t(t("Day End Setting"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Supplier Payment"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/supplier-payment",
                          _t(t("Supplier Payment"))
                        )
                      ) : ""}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Moving Avg"
                        ) ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/moving-avg-process",
                          _t(t("Moving Avg"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null ? (
                        managePageHrefLinkMobile(
                          "/dashboard/manage/stock/demand-generation",
                          _t(t("Demand & Generation"))
                        )
                      ) : ""}
                    </>
                  )
                }

                {/* User Management */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage User"
                  ) ? (
                  <>
                    {managePageHrefLinkMobile(
                      "/dashboard/manage/user/admin-staff",
                      _t(t("Admin / Staff"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/user/till",
                      _t(t("User Till"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/user/customers",
                      _t(t("Customers"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/user/delivery-men",
                      _t(t("Delivery"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/user/waiters",
                      _t(t("Waiters"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/roles-and-permissions",
                      _t(t("Role Groups"))
                    )}
                  </>
                ) : ""}

                {/* Restaurant */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage Restauant"
                  ) ? (
                  <>
                    {managePageHrefLinkMobile(
                      "/dashboard/manage/restaurant/companies",
                      _t(t("Companies"))
                    )}

                    {managePageHrefLinkMobile(
                        "/dashboard/manage/settings/location-setup",
                        _t(t("Location Setup"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/restaurant/branches",
                      _t(t("Branches"))
                    )}

                    {/* Microsoft Dynamics - grouped like Recipe */}
                    <li
                      className="fk-sm-nav__list font-weight-bold text-capitalize border-bottom"
                      style={{ fontSize: "14px", padding: "8px 12px", listStyle: "none" }}
                    >
                      - {_t(t("Microsoft Dynamics"))}
                    </li>
                    {managePageHrefLinkMobile(
                      "/dashboard/manage/restaurant/md-integration",
                      _t(t("Md Integration"))
                    )}
                    {authUserInfo.permissions !== null &&
                      checkPermission(
                        authUserInfo.permissions,
                        "Md Jv"
                      )
                      ? managePageHrefLinkMobile(
                        "/dashboard/manage/restaurant/md-jv",
                        _t(t("Md Jv"))
                      )
                      : ""}

                    {/* {managePageHrefLinkMobile(
                      "/dashboard/manage/restaurant/locations",
                      _t(t("Location"))
                    )}   */}

                      {managePageHrefLinkMobile(
                        "/dashboard/manage/restaurant/areas",
                        _t(t("Areas"))
                      )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/restaurant/zones",
                      _t(t("Zones"))
                    )}

                    {/* {managePageHrefLinkMobile(
                      "/dashboard/manage/restaurant/reasons",
                      _t(t("Reason"))
                    )} */}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/restaurant/order-types",
                      _t(t("Order Types"))
                    )}

                    {/* {managePageHrefLinkMobile(
                      "/dashboard/manage/restaurant/dept-tags",
                      _t(t("Dept Tags"))
                    )} */}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/restaurant/tables",
                      _t(t("Tables"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/restaurant/payment-type",
                      _t(t("Payment Types"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/restaurant/bank-name",
                      _t(t("Bank Name"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/restaurant/manage-party",
                      _t(t("Party"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/restaurant/manage-expense",
                      _t(t("Expense"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/restaurant/party-history",
                      _t(t("Party History"))
                    )}
                    {managePageHrefLinkMobile(
                      "/dashboard/manage/restaurant/manage-kot",
                      _t(t("Manage KOT"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/restaurant/settlements",
                      _t(t("Settlements"))
                    )}

                    {/* website */}
                    {managePageHrefLinkMobile(
                      "/dashboard/manage/website/hero-section",
                      _t(t("Hero Section"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/website/promotions",
                      _t(t("Promotions"))
                    )}
                  </>
                ) : ""}

                {/* Settings */}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Manage Settings"
                  ) ? (
                  <>
                    {managePageHrefLinkMobile(
                      "/dashboard/manage/settings/currencies",
                      _t(t("Currencies"))
                    )}

                    {authUserInfo.permissions !== null &&
                      checkPermission(
                        authUserInfo.permissions,
                        "Manage Settings"
                      ) ? (
                      managePageHrefLinkMobile(
                        "/dashboard/manage/food/currency-note",
                        _t(t("Currency Note"))
                      )
                    ) : ""
                    }

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/settings/languages",
                      _t(t("Languages"))
                    )}

                    {/*managePageHrefLinkMobile(
                      "/dashboard/manage/settings/smtp-settings",
                      _t(t("Email / Smtp"))
                    )*/}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/settings/email-settings",
                      _t(t("Email Template"))
                    )}

                    {/*managePageHrefLinkMobile(
                      "/dashboard/manage/settings/pos-screen",
                      _t(t("Pos Screen"))
                    )*/}

                    {/*managePageHrefLinkMobile(
                      "/dashboard/manage/settings/update-system",
                      _t(t("Update System"))
                    )*/}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/settings/general-settings",
                      _t(t("General Settings"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/settings/web-mapping",
                      _t(t("Web Mapping"))
                    )}

                    {managePageHrefLinkMobile(
                      "/dashboard/manage/settings/offline-table",
                      _t(t("Offline Table"))
                    )}

                    {authUserInfo?.details?.user_type === "superAdmin" && managePageHrefLinkMobile(
                      "/dashboard/manage/settings/generate-test-controller",
                      _t(t("Generate Test Controller"))
                    )}
                  </>
                ) : ""}
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* Navigation for Small Screen  End*/}

      {/* Navigation for large Screen  */}
      <div className="d-none d-lg-block">
        {renderSearchBar(false)}

        {searchTerm.trim() && matchCount === 0 && (
          <div className="text-center py-4 px-3 bg-white rounded border my-2 shadow-sm">
            <div className="mb-2">
              <i className="fa fa-search text-muted" style={{ fontSize: "22px" }}></i>
            </div>
            <p className="text-dark font-weight-bold mb-1" style={{ fontSize: "13px" }}>
              {_t(t("No menus found"))}
            </p>
            <p className="text-muted mb-3" style={{ fontSize: "11.5px" }}>
              {_t(t("No menus match"))} "{searchTerm}"
            </p>
            <button
              type="button"
              className="btn btn-sm btn-outline-danger px-3 py-1 font-weight-bold"
              style={{ fontSize: "11px", borderRadius: "20px" }}
              onClick={() => setSearchTerm("")}
            >
              <i className="fa fa-times mr-1"></i> {_t(t("Clear Search"))}
            </button>
          </div>
        )}

        <div
          className="fk-scroll--pos-menu manage-sidebar-scroll"
          style={{ display: searchTerm.trim() && matchCount === 0 ? "none" : undefined }}
        >
          <ul className="t-list fk-pos-nav">
            {/* Foods */}
            {authUserInfo.permissions !== null &&
              checkPermission(
                authUserInfo.permissions,
                "Manage Food"
              ) ? (
              <li
                className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${window.location.pathname.includes("/food/") ? "active" : ""
                  }`}
              >
                <a
                  className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                  rel="noopener noreferrer"
                  href="#"
                >
                  {_t(t("Foods"))}
                </a>
                <ul className="t-list fk-pos-nav__sub t-bg-white list-group">
                  {managePageHrefLink(
                    "/dashboard/manage/food/add-menu",
                    _t(t("Menu"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/food/department",
                    _t(t("Food Department"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/food/meal-times",
                    _t(t("Meal Time"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/food/add-new",
                    _t(t("Add new item"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/food/all-items",
                    _t(t("All Items"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/food/groups",
                    _t(t("Groups"))
                  )}

                  {parseInt(getSystemSettings(generalSettings, "foods_in_setting")) === 1 && managePageHrefLink(
                    "/dashboard/manage/food/sub-category",
                    _t(t("Sub Category"))
                  )}

                  {/* {managePageHrefLink(
                    "/dashboard/manage/food/units",
                    _t(t("Units"))
                  )} */}

                  {managePageHrefLink(
                    "/dashboard/manage/food/properties",
                    _t(t("Properties Group"))
                  )}
                  {managePageHrefLink(
                    "/dashboard/manage/food/properties-item",
                    _t(t("Properties Item"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/food/variations",
                    _t(t("Variations"))
                  )}
                  {
                    parseInt(getSystemSettings(generalSettings, "foods_in_setting")) === 1 && (
                      <>
                        {managePageHrefLink(
                          "/dashboard/manage/food/food-status",
                          _t(t("Food Status"))
                        )}
                        {managePageHrefLink(
                          "/dashboard/manage/food/product-type",
                          _t(t("Product Type"))
                        )}
                        {managePageHrefLink(
                          "/dashboard/manage/food/tax-group",
                          _t(t("Tax Group"))
                        )}
                        {managePageHrefLink(
                          "/dashboard/manage/food/packing-type",
                          _t(t("Packing Types"))
                        )}
                        {managePageHrefLink(
                          "/dashboard/manage/food/region",
                          _t(t("Regions"))
                        )}
                        {managePageHrefLink(
                          "/dashboard/manage/food/comment",
                          _t(t("Comments"))
                        )}
                        {managePageHrefLink(
                          "/dashboard/manage/food/generic",
                          _t(t("Generic type"))
                        )}
                        {managePageHrefLink(
                          "/dashboard/manage/food/production-unit",
                          _t(t("Product Unit"))
                        )}
                        {managePageHrefLink(
                          "/dashboard/manage/food/variant",
                          _t(t("Variant"))
                        )}
                        {managePageHrefLink(
                          "/dashboard/manage/food/weight",
                          _t(t("Weight"))
                        )}
                        {managePageHrefLink(
                          "/dashboard/manage/food/flavor",
                          _t(t("Flavor"))
                        )}
                        {managePageHrefLink(
                          "/dashboard/manage/food/season",
                          _t(t("Seasons"))
                        )}
                      </>
                    )
                  }
                  {managePageHrefLink(
                    "/dashboard/manage/food/add-voucher",
                    _t(t("Voucher Settings"))
                  )}
                  {managePageHrefLink(
                    "/dashboard/manage/food/add-cards",
                    _t(t("Card Settings"))
                  )}
                  {managePageHrefLink(
                    "/dashboard/manage/food/add-schemes",
                    _t(t("Offers"))
                  )}
                </ul>
              </li>
            )
              : ""}

            {/* stock Management */}
            {showManageStock ? (
              <li
                className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${window.location.pathname.includes("stock") ? "active" : ""
                  }`}
              >
                <a
                  className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                  rel="noopener noreferrer"
                  href=""
                >
                  {_t(t("Manage Stock"))}
                </a>
                <ul className="t-list fk-pos-nav__sub t-bg-white list-group">
                  
                  {/*{authUserInfo.permissions !== null &&
                    checkPermission(
                      authUserInfo.permissions,
                      "MS Food Purchase"
                    ) ? (
                    managePageHrefLink(
                      "/dashboard/manage/stock/food-purchase",
                      _t(t("Food Purchase"))
                    )
                  ) : ""} */}


                  {/* {authUserInfo.permissions !== null &&
                    checkPermission(
                      authUserInfo.permissions,
                      "MS Purchase History"
                    ) ? (
                    managePageHrefLink(
                      "/dashboard/manage/stock/purchase-history-food",
                      _t(t("Purchase History"))
                    )
                  ) : ""} */}
                  {/* finished goods */}
                  <li
                    className={`fk-pos-nav__list fk-pos-nav__list-has-sub__tree ${(url.includes("finished-goods") || url.includes("packing") || url.startsWith("/dashboard/manage/stock/fg-requisition")
                      || url.startsWith("/dashboard/manage/stock/fg-sale-invoice") || url.includes("fg-sale-return") || url.startsWith("/dashboard/manage/stock/fg-issuance") ||
                      url.includes("gift-hampers")) || url.startsWith("/dashboard/manage/stock/fg-sale-order") || url.startsWith("/dashboard/manage/stock/finished-goods-discard") ? "active" : ""
                      }`}
                    style={{ marginBottom: "0px" }}
                  >
                    <a
                      className="w-100 d-flex justify-content-between align-items-center t-text-dark btn border-bottom font-weight-bold text-capitalize rounded-0 text-left"
                      rel="noopener noreferrer"
                      href=""
                      style={{ fontSize: "14px" }}
                    >
                      <span>
                        - {_t(t("Finished Goods"))}
                      </span>
                      <i className="fa fa-caret-down fa-lg" aria-hidden="true"></i>
                    </a>
                    <ul className="t-list fk-pos-nav__sub__tree t-bg-white list-group">

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Finished Goods"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/finished-goods-history",
                          _t(t("Finished Goods"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Finished Goods Transfer"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/finished-goods-transfer",
                          _t(t("Finished Goods Transfer"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Goods Acceptance"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/finished-goods-acceptance",
                          _t(t("Goods Acceptance"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Finished Goods Requisition"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/fg-requisition",
                          _t(t("Finished Goods Requisition"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Finished Goods Issuance"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/fg-issuance",
                          _t(t("Finished Goods Issuance"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS FG PI"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/fg-purchase",
                          _t(t("Finished Goods Purchase"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Finished Goods Discard"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/finished-goods-discard",
                          _t(t("Finished Goods Discard"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Goods Adjustment"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/finished-goods-adjustment",
                          _t(t("Goods Adjustment"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Sale Order"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/fg-sale-order",
                          _t(t("FG Sale Order"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Sale Order"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/fg-sale-invoice",
                          _t(t("FG Sale Invoice"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Sale Order"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/fg-sale-return",
                          _t(t("FG Sale Return"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS FG Packing"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/fg-packing",
                          _t(t("FG Packing"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS FG Hampers"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/gift-hampers",
                          _t(t("Gift Hampers"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS FG Hampers"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/gift-hampers-return",
                          _t(t("Gift Hampers Return"))
                        )
                      ) : ""}

                    </ul>
                  </li>

                  {/* Grn order */}
                  <li
                    className={`fk-pos-nav__list fk-pos-nav__list-has-sub__tree ${(url.includes("purchase-order") || url.includes("sale-invoice") || url.startsWith("/dashboard/manage/stock/sale-return") ||
                      url.includes("purchase-return") || url.includes("purchase-invoice") || url.includes("purchase-request") || url.includes("goods-received-note") || url.includes("bank-drop")) ? "active" : ""}`}
                    style={{ marginBottom: "0px" }}
                  >
                    <a
                      className="w-100 d-flex justify-content-between align-items-center t-text-dark btn border-bottom font-weight-bold text-capitalize rounded-0 text-left"
                      rel="noopener noreferrer"
                      href=""
                      style={{ fontSize: "14px" }}
                    >
                      <span>
                        - {_t(t("Purchase Manage"))}
                      </span>
                      <i className="fa fa-caret-down fa-lg" aria-hidden="true"></i>
                    </a>
                    <ul className="t-list fk-pos-nav__sub__tree t-bg-white list-group">

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Purchase Request"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/purchase-request",
                          _t(t("Purchase Request"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Purchase Order"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/purchase-order",
                          _t(t("Purchase Order"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Goods Recieved Note"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/goods-received-note",
                          _t(t("Goods Recieved Note"))
                        )
                      ) : ""}

                      {parseInt(getSystemSettings(generalSettings, "foods_in_setting")) === 1 && authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Goods Recieved Note"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/goods-received-note-dept",
                          _t(t("GRN Department"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Purchase Invoice"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/purchase-invoice",
                          _t(t("Purchase Invoice"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Purchase Return"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/purchase-return",
                          _t(t("Purchase Return"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Sale Invoice"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/sale-invoice",
                          _t(t("Sale Invoice"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Sale Invoice"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/sale-return",
                          _t(t("Sale Return"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Bank Drop"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/bank-drop",
                          _t(t("Bank Drop"))
                        )
                      ) : ""}

                    </ul>
                  </li>

                  {/* Recipe  */}

                  <li
                    className={`fk-pos-nav__list fk-pos-nav__list-has-sub__tree ${url.includes("recipe") || url.includes("ingredient") ||
                      url.includes("supplier") || url.includes("production") || url.includes("closing") || url.includes("wastage") || url.includes("brand") ? "active" : ""
                      }`}
                    style={{ marginBottom: "0px" }}
                  >
                    <a
                      className="w-100 d-flex justify-content-between align-items-center t-text-dark btn border-bottom font-weight-bold text-capitalize rounded-0 text-left"
                      rel="noopener noreferrer"
                      href=""
                      style={{ fontSize: "14px" }}
                    >
                      <span>
                        - {_t(t("Recipe"))}
                      </span>
                      <i className="fa fa-caret-down fa-lg" aria-hidden="true"></i>
                    </a>
                    <ul className="t-list fk-pos-nav__sub__tree t-bg-white list-group">

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Recipe"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/view-recipe",
                          _t(t("Recipe"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Recipe"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/bulk-update-recipe",
                          _t(t("Update Recipe"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Wastage Food"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/wastage-food",
                          _t(t("Wastage Food"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Ingredient Group"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/ingredient-group",
                          _t(t("Ingredient Group"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Ingredient Group"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/brand",
                          _t(t("Brands"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Ingredient Unit"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/ingredient-unit",
                          _t(t("Ingredient Unit"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Ingredient Item"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/ingredient-item",
                          _t(t("Ingredient Item"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        (checkPermission(
                          authUserInfo.permissions,
                          "MS Peeling Process"
                        ) ||
                          checkPermission(
                            authUserInfo.permissions,
                            "MS Ingredient Item"
                          )) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/peeling-process",
                          _t(t("Peeling Process"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Ingredient Item"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/ingredient-limit",
                          _t(t("Ingredient limit"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Closing Stock"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/closing-stock",
                          _t(t("Closing Stock"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Manage Supplier"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/manage-supplier",
                          _t(t("Manage Supplier"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Production"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/production",
                          _t(t("Production"))
                        )
                      ) : ""}

                    </ul>
                  </li>

                  {/* Stock */}

                  <li
                    className={`fk-pos-nav__list fk-pos-nav__list-has-sub__tree ${url.includes("stock-consumption") || url.includes("requisition") ||
                      url.includes("issuance") || url.includes("stock-receiving") || url.includes("stock-transfer") ||
                      url.includes("stock-adjustment") || url.includes("opening") ? "active" : ""
                      }`}
                    style={{ marginBottom: "0px" }}
                  >
                    <a
                      className="w-100 d-flex justify-content-between align-items-center t-text-dark btn border-bottom font-weight-bold text-capitalize rounded-0 text-left"
                      rel="noopener noreferrer"
                      href=""
                      style={{ fontSize: "14px" }}
                    >
                      <span>
                        - {_t(t("Stock"))}
                      </span>
                      <i className="fa fa-caret-down fa-lg" aria-hidden="true"></i>
                    </a>
                    <ul className="t-list fk-pos-nav__sub__tree t-bg-white list-group">

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Stock Transfer"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/stock-consumption",
                          _t(t("Stock Consumption"))
                        )
                      ) : ""}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Store Requisition"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/store-requisition",
                          _t(t("Store Requisition"))
                        )
                      ) : ""}
                      
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Stock Issuance"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/stock-issuance",
                          _t(t("Stock Issuance"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Store Requisition"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/stock-receiving",
                          _t(t("Stock Receiving"))
                        )
                      ) : ""}

                       {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Store Requisition"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/store-requisition-dept",
                          _t(t("Store Requisition Dept"))
                        )
                      ) : ""}
                      
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Stock Issuance"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/stock-issuance-dept",
                          _t(t("Stock Issuance Dept"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Store Requisition"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/stock-receiving-dept",
                          _t(t("Stock Receiving Dept"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Stock Transfer"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/stock-transfer",
                          _t(t("Stock Transfer"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Stock Adjustment"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/stock-adjustment",
                          _t(t("Stock Adjustment"))
                        )
                      ) : ""}

                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "MS Opening Stock"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/stock/opening-stock",
                          _t(t("Opening Stock"))
                        )
                      ) : ""}

                    </ul>
                  </li>

                  {authUserInfo.permissions !== null &&
                    checkPermission(
                      authUserInfo.permissions,
                      "MS Gate Pass"
                    ) ? (
                    managePageHrefLink(
                      "/dashboard/manage/stock/gate-pass",
                      _t(t("Gate Pass"))
                    )
                  ) : ""}

                  {authUserInfo.permissions !== null &&
                    checkPermission(
                      authUserInfo.permissions,
                      "MS Day End Setting"
                    ) ? (
                    managePageHrefLink(
                      "/dashboard/manage/stock/day-end-setting",
                      _t(t("Day End Setting"))
                    )
                  ) : ""}

                  {authUserInfo.permissions !== null &&
                    checkPermission(
                      authUserInfo.permissions,
                      "MS Barcode Print"
                    ) ? (
                    managePageHrefLink(
                      "/dashboard/manage/stock/barcode-print-add",
                      _t(t("Barcode Print"))
                    )
                  ) : ""}

                  {authUserInfo.permissions !== null &&
                    checkPermission(
                      authUserInfo.permissions,
                      "MS Supplier Payment"
                    ) ? (
                    managePageHrefLink(
                      "/dashboard/manage/stock/supplier-payment",
                      _t(t("Supplier Payment"))
                    )
                  ) : ""}

                  {authUserInfo.permissions !== null &&
                    checkPermission(
                      authUserInfo.permissions,
                      "Moving Avg"
                    ) ? (
                    managePageHrefLink(
                      "/dashboard/manage/stock/moving-avg-process",
                      _t(t("Moving Avg"))
                    )
                  ) : ""}

                  {authUserInfo.permissions !== null ? (
                    managePageHrefLink(
                      "/dashboard/manage/stock/demand-generation",
                      _t(t("Demand & Generation"))
                    )
                  ) : ""}
                </ul>
              </li>
            ) : (
              ""
            )}


            {/* User Management */}
            {authUserInfo.permissions !== null &&
              checkPermission(
                authUserInfo.permissions,
                "Manage User"
              ) ? (
              <li
                className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${window.location.pathname.includes("/roles") ||
                  window.location.pathname.includes("/user/") ||
                  window.location.pathname.includes("/till/")
                  ? "active" : ""
                  }`}
              >
                <a
                  className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                  rel="noopener noreferrer"
                  href="#"
                >
                  {_t(t("User Management"))}
                </a>
                <ul className="t-list fk-pos-nav__sub t-bg-white list-group">
                  {managePageHrefLink(
                    "/dashboard/manage/user/admin-staff",
                    _t(t("Admin / Staff"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/user/till",
                    _t(t("User Till"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/user/customers",
                    _t(t("Customers"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/user/waiters",
                    _t(t("Waiters"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/roles-and-permissions",
                    _t(t("Role Groups"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/user/delivery-men",
                    _t(t("Delivery User"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/user/delivery-request",
                    _t(t("New Delivery User"))
                  )}
                </ul>
              </li>
            ) : ""}

            {/* Restaurant */}
            {authUserInfo.permissions !== null &&
              checkPermission(
                authUserInfo.permissions,
                "Manage Restaurant"
              ) ? (
              <li
                className={`fk-pos-nav__list fk-pos-nav__list-has-sub 
                ${window.location.pathname.includes("/restaurant") ? "active" : ""
                  }`}
              >
                <a
                  className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                  rel="noopener noreferrer"
                  href="#"
                >
                  {_t(t("Restaurant"))}
                </a>
                  <ul className="t-list fk-pos-nav__sub t-bg-white list-group">
                  {managePageHrefLink(
                    "/dashboard/manage/restaurant/companies",
                    _t(t("Companies"))
                  )}


                    {managePageHrefLink(
                      "/dashboard/manage/settings/location-setup",
                      _t(t("Location Setup"))
                    )}

                    {managePageHrefLink(
                      "/dashboard/manage/restaurant/branches",
                      _t(t("Branches"))
                    )}

                  {/* MD */}
                  <li
                    className={`fk-pos-nav__list fk-pos-nav__list-has-sub__tree ${url.includes("md-integration") || url.includes("md-jv") ? "active" : ""
                      }`}
                    style={{ marginBottom: "0px" }}
                  >
                    <a
                      className="w-100 d-flex justify-content-between align-items-center t-text-dark btn border-bottom font-weight-bold text-capitalize rounded-0 text-left"
                      rel="noopener noreferrer"
                      href=""
                      style={{ fontSize: "14px" }}
                    >
                      <span>
                        - {_t(t("Microsoft Dynamics"))}
                      </span>
                      <i className="fa fa-caret-down fa-lg" aria-hidden="true"></i>
                    </a>
                    <ul className="t-list fk-pos-nav__sub__tree t-bg-white list-group">
                      {managePageHrefLink(
                        "/dashboard/manage/restaurant/md-integration",
                        _t(t("Md Integration"))
                      )}
                      {authUserInfo.permissions !== null &&
                        checkPermission(
                          authUserInfo.permissions,
                          "Md Jv"
                        ) ? (
                        managePageHrefLink(
                          "/dashboard/manage/restaurant/md-jv",
                          _t(t("Md Jv"))
                        )
                      ) : ""}
                    </ul>
                  </li>

                  {/* {managePageHrefLink(
                    "/dashboard/manage/restaurant/locations",
                    _t(t("Location"))
                  )}   */}

                    {managePageHrefLink(
                      "/dashboard/manage/restaurant/areas",
                      _t(t("Areas"))
                    )}

                  {managePageHrefLink(
                    "/dashboard/manage/restaurant/zones",
                    _t(t("Zones"))
                  )}

                  {/* {managePageHrefLink(
                    "/dashboard/manage/restaurant/reasons",
                    _t(t("Reason"))
                  )} */}

                  {managePageHrefLink(
                    "/dashboard/manage/restaurant/order-types",
                    _t(t("Order Types"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/restaurant/table-floor",
                    _t(t("Table Floor"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/restaurant/tables",
                    _t(t("Tables"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/restaurant/payment-type",
                    _t(t("Payment Types"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/restaurant/bank-name",
                    _t(t("Bank Name"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/restaurant/manage-party",
                    _t(t("Party"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/restaurant/manage-expense",
                    _t(t("Expense"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/restaurant/party-history",
                    _t(t("Party History"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/restaurant/manage-kot",
                    _t(t("Manage KOT"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/restaurant/settlement",
                    _t(t("Settlements"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/restaurant/kds-setting",
                    _t(t("KDS Setting"))
                  )}
                </ul>
              </li>
            ) : ""}

            {/* website */}
            {/* <li
              className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${window.location.pathname.includes("/website/") ? "active" : ""
                }`}
            >
              <a
                className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                rel="noopener noreferrer"
                href="#"
              >
                {_t(t("Website"))}
              </a>
              <ul className="t-list fk-pos-nav__sub t-bg-white list-group">
                {managePageHrefLink(
                  "/dashboard/manage/website/hero-section",
                  _t(t("Hero Section"))
                )}

                {managePageHrefLink(
                  "/dashboard/manage/website/promotions",
                  _t(t("Promotions"))
                )}
              </ul>
            </li> */}

            {/* Settings */}
            {authUserInfo.permissions !== null &&
              checkPermission(
                authUserInfo.permissions,
                "Manage Settings"
              ) ? (
              <li
                className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${window.location.pathname.includes("/settings/") ? "active" : ""
                  }`}
              >
                <a
                  className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                  rel="noopener noreferrer"
                  href="#"
                >
                  {_t(t("Settings"))}
                </a>
                <ul className="t-list fk-pos-nav__sub t-bg-white list-group">
                  {managePageHrefLink(
                    "/dashboard/manage/settings/currencies",
                    _t(t("Currencies"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/settings/currency-note",
                    _t(t("Currency Note"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/settings/languages",
                    _t(t("Languages"))
                  )}

                  {/*managePageHrefLink(
                    "/dashboard/manage/settings/smtp-settings",
                    _t(t("Email / Smtp"))
                  )*/}

                  {managePageHrefLink(
                    "/dashboard/manage/settings/email-settings",
                    _t(t("Email Template"))
                  )}

                  {/*managePageHrefLink(
                    "/dashboard/manage/settings/pos-screen",
                    _t(t("Pos Screen"))
                  )*/}

                  {managePageHrefLink(
                    "/dashboard/manage/settings/setup-payment",
                    _t(t("Payment Setup"))
                  )}

                  {/*managePageHrefLink(
                    "/dashboard/manage/settings/update-system",
                    _t(t("Update System"))
                  )*/}

                  {managePageHrefLink(
                    "/dashboard/manage/settings/general-settings",
                    _t(t("General Settings"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/settings/web-mapping",
                    _t(t("Web Mapping"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/settings/offline-table",
                    _t(t("Offline Tables"))
                  )}

                  {authUserInfo?.details?.user_type === "superAdmin" && managePageHrefLink(
                    "/dashboard/manage/settings/generate-test-controller",
                    _t(t("Generate Test Controller"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/settings/show-delivery-menu",
                    _t(t("Show Deliverymen"))
                  )}

                  {managePageHrefLink(
                    "/dashboard/manage/settings/show-manage-stock-menu",
                    _t(t("Show Manage Stock"))
                  )}
                  {managePageHrefLink(
                    "/dashboard/manage/settings/update-settings",
                    _t(t("Update Settings"))
                  )}
                </ul>
              </li>
            ) : ""}
          </ul>
        </div>
      </div>
      {/* Navigation for large Screen End */}
    </>
  );
};

export default ManageSidebar;
